import { render, staticRenderFns } from "./emojiTextarea.vue?vue&type=template&id=d266dda4"
import script from "./emojiTextarea.vue?vue&type=script&lang=js"
export * from "./emojiTextarea.vue?vue&type=script&lang=js"
import style0 from "./emojiTextarea.vue?vue&type=style&index=0&id=d266dda4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports